import React, { useState, useEffect } from "react";
import {
  Drawer,
  Box,
  Typography,
  TextField,
  Button,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import api from "../../../services/api";

const CakeAttributeFormDrawer = ({ open, onClose, onSave, attributeData }) => {
  const isEditMode = Boolean(attributeData);

  const [formData, setFormData] = useState({
    type: "",
    name: "",
    slug: "",
    price: "",
    img: "",
    description: "",
    visibility: true,
  });

  useEffect(() => {
    if (attributeData) {
      setFormData({
        ...attributeData,
        price: attributeData.price || "",
        visibility: attributeData.visibility ?? true,
      });
    }
  }, [attributeData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "name" && !isEditMode
        ? { slug: value.toLowerCase().replace(/\s+/g, "-") }
        : {}),
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: checked }));
  };

  const handleSubmit = async () => {
    try {
      if (isEditMode) {
        await api.put(`/cake-attributes/${attributeData._id}`, formData);
      } else {
        await api.post("/cake-attributes", formData);
      }
      onSave();
      onClose();
    } catch (error) {
      console.error("Error saving attribute:", error);
    }
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width: { xs: "100%", md: 400 } } }}>
      <Box sx={{ p: 3 }}>
        <Typography variant="h5" fontWeight={700} mb={3}>
          {isEditMode ? "Edit Attribute" : "Add New Attribute"}
        </Typography>

        <Select
          name="type"
          value={formData.type}
          onChange={handleInputChange}
          fullWidth
          displayEmpty
          sx={{ mb: 2 }}>
          <MenuItem value="" disabled>
            Select Type
          </MenuItem>
          <MenuItem value="style">Style</MenuItem>
          <MenuItem value="texture">Texture</MenuItem>
          <MenuItem value="decor">Decor</MenuItem>
        </Select>

        <TextField
          label="Name"
          name="name"
          value={formData.name}
          onChange={handleInputChange}
          fullWidth
          margin="dense"
        />
        <TextField
          label="Slug (auto)"
          name="slug"
          value={formData.slug}
          disabled
          fullWidth
          margin="dense"
        />
        <TextField
          label="Price"
          name="price"
          value={formData.price}
          onChange={handleInputChange}
          type="number"
          fullWidth
          margin="dense"
        />
        <TextField
          label="Image URL"
          name="img"
          value={formData.img}
          onChange={handleInputChange}
          fullWidth
          margin="dense"
        />
        <TextField
          label="Description"
          name="description"
          value={formData.description}
          onChange={handleInputChange}
          fullWidth
          margin="dense"
          multiline
          rows={3}
        />

        <FormControlLabel
          control={
            <Checkbox
              name="visibility"
              checked={formData.visibility}
              onChange={handleCheckboxChange}
            />
          }
          label="Visible"
          sx={{ mt: 2 }}
        />

        <Button
          variant="contained"
          onClick={handleSubmit}
          fullWidth
          sx={{ mt: 4 }}>
          {isEditMode ? "Save Changes" : "Add Attribute"}
        </Button>
      </Box>
    </Drawer>
  );
};

export default CakeAttributeFormDrawer;
